import React from 'react';

class DifficultyAwareComponent extends React.Component {
  render() {
    if(!this.props.project) console.warn('Redux state `project` is required for difficulty aware rendering');
    if(!this.props.project || this.props.project.difficulty==="PRO") return this.renderHoog();
    return this.renderLaag();
  }

  renderHoog() {
    console.error('Difficulty aware rendering is not implemented in extended component.');
  }

  renderLaag() {
    console.error('Difficulty aware rendering is not implemented in extended component.');
  }
}

export default DifficultyAwareComponent;



// WEBPACK FOOTER //
// ./src/components/DifficultyAwareComponent.js